

const state = {
    period_config:[],
};

const mutations = {
    UPDATE_PERIOD_CONFIG: (state, data) => {
        state.period_config = [...data];
    },

};


export default {
    namespaced: true,
    state,
    mutations,
}
